module.exports = __webpack_public_path__ + "static/LFO_panel-b3ab605367fade9e5f8b7642cb3fd6d7.png";